import { getCookie } from './getCookie'

/**
 * Cookie delete
 * @param cname {string} - cookie name
 */
export function deleteCookie(cname: string) {
  const { document } = window
  if (document && getCookie(cname)) {
    document.cookie = `${cname}=; path=/; expires = Thu, 01 Jan 1970 00:00:01 GMT`
  }
}
